import React from 'react';
import styles from './index.module.scss';

interface Props {
  className?: string;
}

const UnderApprovalTag: React.FC<Props> = ({ className = '' }) => {
  return <div className={styles.under_approval_tag + ' ' + className}>审批中</div>;
};

export default UnderApprovalTag;
